import React from 'react';
import GlobalBreadcrumbs from '../../components/global/GlobalBreadcrumbs';
import WrapperSection from '../../components/global/WrapperSection';
import FormAddEditDepartment from '../../components/departments/FormAddEditDepartment';
import { useParams } from 'react-router-dom';
import { useGetDepartment } from '../../hooks/departments/useGetDepartment';
import LoadingPage from '../../components/global/LoadingPage';

const EditDepartment = () => {
    const { id } = useParams();
    const { department, isLoading } = useGetDepartment(id);

    if (isLoading) return <LoadingPage />;

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditDepartment isEdit currentData={department?.data} />
        </WrapperSection>
    );
};

export default EditDepartment;
